import { Link, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'

const navItems = [
  { path: '/today', label: 'Asosiy', icon: '🏠' },
  { path: '/habits', label: 'Odatlar', icon: '✅' },
  { path: '/journal', label: 'Daftar', icon: '📔' },
  { path: '/finance', label: 'Moliya', icon: '💰' },
  { path: '/kanban', label: 'Reja', icon: '📋' },
]

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation()

  return (
    <div className="min-h-screen flex flex-col bg-background">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-surface/80 backdrop-blur-md safe-top border-b border-gray-100">
        <div className="max-w-md mx-auto px-4 h-14 flex items-center justify-between">
          <h1 className="text-lg font-bold text-primary">UzMentor</h1>
          <Link
            to="/settings"
            className="touch-target flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 active:bg-gray-200 transition-colors"
            aria-label="Sozlamalar"
          >
            ⚙️
          </Link>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 max-w-md mx-auto w-full">
        {children}
      </main>

      {/* Bottom Navigation */}
      <nav className="sticky bottom-0 z-40 bg-surface/90 backdrop-blur-md safe-bottom border-t border-gray-100">
        <div className="max-w-md mx-auto flex justify-around items-center h-16">
          {navItems.map((item) => {
            const isActive =
              location.pathname === item.path ||
              location.pathname.startsWith(item.path + '/')
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center justify-center touch-target w-16 gap-0.5 transition-colors ${
                  isActive ? 'text-primary' : 'text-text-secondary'
                }`}
              >
                <span className="text-xl">{item.icon}</span>
                <span className="text-[10px] font-medium">{item.label}</span>
              </Link>
            )
          })}
        </div>
      </nav>
    </div>
  )
}
